import { Context } from "@microsoft/fast-element/context.js";

// TODO: Perhaps this should be controlled by having a "surface" component that is part of any other component that has a background color?
export const backgroundColorContext = Context.create<boolean>('background-color-context', false);